import { useAuth } from '../../../context/AuthContext'
import ListModule from '../../module/ListModule'
import { useOutletContext } from 'react-router-dom'
import { customerColumns } from './CustomerFields'
import { useMemo } from 'react'

const ListCustomers = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()
  const companyId = user?.company_id

  const objectFilter = useMemo(() => ({ owner_id: companyId }), [companyId])

  const options = useMemo(() => {
    if (!companyId) return null

    return {
      objectType: 'customers',
      accessRight: userRight,
      objectFilter: () => objectFilter,
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le client',
          field: 'customer_name'
        }
      },
      isExpand: false,
      isFilter: true,
      columns: customerColumns
    }
  }, [companyId, userRight, objectFilter])

  const toolbar = useMemo(
    () => ({
      objectType: 'customers',
      accessRight: userRight,
      title: 'Clients',
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListCustomers
